export var nullRender = function () { return null; };
//# sourceMappingURL=nullRender.js.map